export class ExecutionResponse {
    errorMessage?: string
    errorMessages: string[] = []
    exception?: any
    hasMultipleErrors: boolean = false
    message?: string
    success: boolean = true
    status?: number

    constructor(options?: Partial<ExecutionResponse>) {
        if (options) {
            Object.assign(this, options)
        }
    }
}

export class SingleResponse<T> extends ExecutionResponse {
    model: T | undefined

    constructor(options?: Partial<SingleResponse<T>>) {
        super(options)

        if (options) {
            this.model = options.model
        }
    }
}